import React from 'react';
import { Navbar } from './Navbar';

const PublicLayout = ({ children }) => {
  return (
    <div className="min-h-screen">
      <Navbar />
      <main>
        {children}
      </main>
    </div>
  );
};

export default PublicLayout;